var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav',{attrs:{"pills":""}},_vm._l((_vm.navigation),function(text,name){return _c('b-nav-item',{key:name,attrs:{"to":{ name: name },"active":_vm.$route.name === name}},[_vm._v(_vm._s(text))])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac907222","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/ProfileNav.vue
// module id = PJPQ
// module chunks = 0